@if (componentData$ | async; as data) {
  @if ((node$ | async)?.children[0]; as nodes) {
    <div class="col-lg-12 float-left p-3 border">
      <div class="w-100 customersearch-title mb-3">
        {{ data.title }}
      </div>
      @if ((node$ | async)?.children[0]; as nodes) {
        <ul class="mb-0 border-top">
          @for (menu of nodes.children[0].links; track menu) {
            <li class="p-2 border-bottom quick-link">
              @if (menu.title && menu.url) {
                <cx-generic-link class="d-block" [url]="menu.url" [target]="menu.target">
                  {{ menu.title }}
                </cx-generic-link>
              }
              @if (menu.media; as media) {
                @if (isExternalUrl(media.url)) {
                  <a [href]="media.url" download target="_blank" (click)="knbrLinkClickEvent(media.altText, data.title)">{{
                    media.altText
                  }}</a>
                } @else {
                  <a
                    [href]="getPDFUrl(media.url)"
                    target="_blank"
                    [download]="media.url.code"
                    >{{ media.altText }}</a
                    >
                  }
                }
              </li>
            }
          </ul>
        }
      </div>
    }
  }
